import { AfterViewInit, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { IActivo } from 'modelos/src';
import {
  LineStringMapa,
  MapaFacilData,
} from '../../../../../auxiliares/mapa-facil/interfaces';
import { MapaFacilService } from '../../../../../auxiliares/mapa-facil/mapa-facil.service';

@Component({
  selector: 'app-detalles-activo-mapa-recorrido',
  templateUrl: './detalles-activo-mapa-recorrido.component.html',
  styleUrl: './detalles-activo-mapa-recorrido.component.scss',
  standalone: false,
})
export class DetallesActivoMapaRecorridoComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private mapaService = inject(MapaFacilService);

  public recorridoMapaFacil?: MapaFacilData = { geoMarker: 'Activo' };
  @Input() activo: IActivo;

  public armarRecorridoParaMapa(coordenadas: [number, number][]) {
    if (coordenadas.length > 0) {
      const center: [number, number] = coordenadas[0];
      const polylines: LineStringMapa[] = this.armarRecorridos(coordenadas);
      this.recorridoMapaFacil = {
        center,
        polylines,
        zoom: 14,
        controlsOnRight: true,
        geoMarker: 'Activo',
      };
    } else {
      const polylines: LineStringMapa[] = [];
      this.recorridoMapaFacil = {
        polylines,
        zoom: 14,
        controlsOnRight: true,
        geoMarker: 'Activo',
      };
    }
    this.mapaService.updateData(this.recorridoMapaFacil);
  }

  private armarRecorridos(coordenadas: [number, number][]) {
    const recorridos: LineStringMapa[] = [];
    const coords = coordenadas;
    const recorrido: LineStringMapa = {
      points: coords,
      color: 'blue',
      width: 2,
      dash: true,
      circlepin: true,
      // arrow: true,
      trip: true,
    };
    recorridos.push(recorrido);
    return recorridos;
  }

  async ngOnInit() {}

  async ngAfterViewInit() {
    this.recorridoMapaFacil = {
      zoom: 14,
      controlsOnRight: true,
      geoMarker: 'Activo',
    };
    this.mapaService.updateData(this.recorridoMapaFacil);
  }

  ngOnDestroy() {}
}
